import { Injectable } from '@angular/core';
import { ApplicationSetting } from '../interface/common.interface';

@Injectable({
  providedIn: 'root',
})
export class AppState {
  /**
   * Stores all the application settings used in the app
   * Value is stored in this variable during application bootstrap
   */
  applicationSettings!: ApplicationSetting;
}
